<template>
    <Alert v-if="alertContent" :loadingMood="false" :alertContent="alertContent" @close="alertContent=''"/>
    <div id="user-home">
        <div class="user-home-header">
            <div class="title form-title"  style="position: relative">
                <div class="line"></div>
                <ul>
                    <li>
                        <img width="30" height="30" src="../../assets/new/New/Icon/Filled/ArrowLeft.png" alt="">
                    </li>
                    <li>
                        اطلاعات کاربری
                    </li>
                </ul>
                <div class="file-details" v-if="clientDashboardInfos">
                    <div class="file-details-section-one" v-if="clientDashboardInfos.fileNumber">
                        پرونده مهاجرتی شماره {{clientDashboardInfos.fileNumber}}
                    </div>
                    <div class="file-details-section-two" v-if="clientDashboardInfos.options">
                        <span v-for="(option , index) in clientDashboardInfos.options" :key="option">
                                <span v-if="index>0">
                                    و
                                </span>
                              {{option}}
                         </span>
                    </div>
                    <span class="mobile-view" v-if="clientDashboardInfos.fileNumber">
                        پرونده مهاجرتی شماره {{clientDashboardInfos.fileNumber}}
                        &#x2190;
                         (
                        <span v-if="clientDashboardInfos.options">
                             <span v-for="(option , index) in clientDashboardInfos.options" :key="option">
                                <span v-if="index>0">
                                    و
                                </span>
                              {{option}}
                            </span>
                        </span>
                        )
                    </span>
                </div>
            </div>
            <div id="action-steps-parent-container">
                <div id="more-details">
                    <div class="title form-title" id="more-details-title" style="position: relative">
                        <div class="line"></div>
                        <ul>
                            <li>
                                <img width="30" height="30" src="../../assets/new/New/Icon/Filled/ArrowLeft.png" alt="icon">
                            </li>
                            <li>
                                اطلاعات کاربری
                            </li>
                        </ul>
                    </div>
                    <div id="more-details-text-content">
                        {{explain}}
                    </div>
                </div>
                <div id="action-steps-parent" v-if="workingSteps" :style="[workingSteps.length > 4 ?{borderLeft:'2px solid black'}:{}]" @mousemove="mousemove" @mousedown="startDragging"
                     @mouseleave="stopDragging" @mouseup="stopDragging(false)" class="parent">
                    <ul class="child" id="action-steps-child" style="position: relative">
                        <li v-for="(step , index) in workingSteps" @mouseover="(e)=>showMoreDetails(e,index)" @mouseleave="hideMoreDetails"
                            :class=
                             "
                              index ==  0 && step.status == 0 ? 'start waiting' :
                              index ==  0 && step.status == 1 ? 'start in-process':
                              index ==  0 && step.status == 2 ? 'start reviewed':

                              index > 0 && index<=workingSteps.length-1 && step.status == 0 ? 'middle waiting' :
                              index > 0 && index<=workingSteps.length-1 && step.status == 1 ? 'middle in-process':
                              index > 0 && index<=workingSteps.length-1 && step.status == 2 ? 'middle reviewed':
                            ''"
                            :style="{zIndex:workingSteps.length - index}" :key="step">
                            <span>
                                {{step.name}}
                            </span>
                            <img :src="
                              index ==  0 && step.status == 0 ?  require('../../assets/appIcons/Stepper/Sketch/sketch-white-start.png') :
                              index ==  0 && step.status == 1 ?  require('../../assets/appIcons/Stepper/Sketch/sketch-black-start.png'):
                              index ==  0 && step.status == 2 ?  require('../../assets/appIcons/Stepper/Sketch/sketch-green-start.png'):

                              index > 0 && index<workingSteps.length-1 && step.status == 0 ?  require('../../assets/appIcons/Stepper/Sketch/sketch-white-middle.png') :
                              index > 0 && index<workingSteps.length-1 && step.status == 1 ?  require('../../assets/appIcons/Stepper/Sketch/sketch-black-middle.png'):
                              index > 0 && index<workingSteps.length-1 && step.status == 2 ?  require('../../assets/appIcons/Stepper/Sketch/sketch-green-middle.png'):

                              index==workingSteps.length-1 && step.status == 0 ?  require('../../assets/appIcons/Stepper/Sketch/sketch-white-end.png') :
                              index==workingSteps.length-1 && step.status == 1 ?  require('../../assets/appIcons/Stepper/Sketch/sketch-black-end.png'):
                              index==workingSteps.length-1 && step.status == 2 ?  require('../../assets/appIcons/Stepper/Sketch/sketch-green-end.png'):
                            ''" alt="icon">
                        </li>
                    </ul>
                </div>
                <div class="waiting-box" v-else>
                    (در انتظار بررسی کارشناس)
                </div>
            </div>
        </div>
        <div class="user-home-body">
            <div class="title form-title"  style="position: relative">
                <div class="line"></div>
                <ul>
                    <li>
                        <img width="30" height="30" src="../../assets/new/New/Icon/Filled/ArrowLeft.png" alt="">
                    </li>
                    <li>
                        مقالات پیشنهادی برای شما
                    </li>
                </ul>
            </div>
            <div class="row news-container"  v-if="relatedPosts">
               <NewsView :userHome="true" v-for="postInfo in relatedPosts" :postInfo="postInfo" :key="postInfo"/>
            </div>
            <div class="row news-container"  v-else>
            <div class="empty-box">
                (محتوایی یافت نشد)
            </div>
            </div>

        </div>
    </div>

        <PanelLoader v-if="loadingMood"/>

</template>

<script>
    import NewsView from '../../components/NewsView'
    import axios from 'axios'
    import Alert from "../../components/Alert"
    import PanelLoader from "../../components/PanelLoader"
    export default {
        name: "UserHome",
        data() {
            return {
                alertContent: null,
                loadingMood: false,
                mouseDown: false,
                startX: null,
                scrollLeft: null,
                childLargerLength: false,
                clientDashboardInfos: null,
                explain:null,
                workingSteps:null,
                relatedPosts:null

            }
        },
        methods: {
            hideMoreDetails: function () {
                document.getElementById('more-details').style.opacity = '0';
            },
            showMoreDetails: function (e,index) {
                this.explain = this.workingSteps[index].explain;
                const idName = "action-steps-parent";
                const slider = document.getElementById(idName);
                e.preventDefault();
                const leftDistance = Math.abs(slider.scrollLeft - e.target.offsetParent.offsetLeft) - (slider.children[0].offsetWidth - slider.offsetWidth) - 75;
                document.getElementById('more-details').style.opacity = '1';
                document.getElementById('more-details').style.left = leftDistance + 'px'
            },
            startDragging: function (e) {
                this.checkSlider();
                if (this.childLargerLength) {
                    const idName = "action-steps-parent";
                    const slider = document.getElementById(idName);
                    this.mouseDown = true;
                    this.startX = e.pageX - slider.offsetLeft;
                    this.scrollLeft = slider.scrollLeft;
                }
            },
            stopDragging: function () {
                this.mouseDown = false;
            },
            mousemove: function (e) {
                this.checkSlider();
                if (this.childLargerLength) {
                    const idName = "action-steps-parent";
                    const slider = document.getElementById(idName);
                    e.preventDefault();
                    if (!this.mouseDown) {
                        return;
                    }
                    const x = e.pageX - slider.offsetLeft;
                    const scroll = x - this.startX;
                    slider.scrollLeft = this.scrollLeft - scroll;
                    if (Math.abs(slider.children[0].offsetWidth - slider.offsetWidth + 4) == Math.abs(slider.scrollLeft)) {
                        document.getElementById(idName).style.borderLeft = 'none'
                    } else {
                        document.getElementById(idName).style.borderLeft = 'solid 2px #162336'
                    }
                    if (slider.scrollLeft == 0) {
                        document.getElementById(idName).style.borderRight = 'none'
                    } else {
                        document.getElementById(idName).style.borderRight = 'solid 2px #162336'
                    }
                }
            },
            checkSlider() {
                if(this.childLargerLength == false){
                    const parent = document.getElementById('action-steps-parent');
                    if(parent!=undefined){
                        const child = document.getElementById('action-steps-child');
                        if (parent.offsetWidth > child.offsetWidth) {
                            this.childLargerLength = false;
                        } else {
                            this.childLargerLength = true;
                            document.getElementById('action-steps-parent').style.borderLeft = 'solid 2px #162336'
                        }
                    }
                }
            },

            async getClientDashboardInfos() {
                try {
                    this.loadingMood = true;
                    const response = await axios.get('api/userDashboard/getClientDashboardInfos', {headers: {"Authorization": `Bearer ${localStorage.getItem('token')}`}});
                    this.loadingMood = false;
                    this.clientDashboardInfos = response.data.results;

                } catch (error) {
                    this.loadingMood = false;
                    this.alertContent = {
                        message: 'خطا در انجام عملیات!',
                        imageUrl: require('../../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                        buttonType: 'close',//close
                        buttonText: 'تایید',
                        buttonLink: '',///personal-info
                        waitingMode: false
                    };
                }
            },
            async getClientRelatedPosts() {
                try {
                    this.loadingMood = true;
                    const response = await axios.get('api/userDashboard/getClientRelatedPosts', {headers: {"Authorization": `Bearer ${localStorage.getItem('token')}`}});
                    this.loadingMood = false;
                    this.relatedPosts = response.data.results;

                } catch (error) {
                    this.loadingMood = false;
                    this.alertContent = {
                        message: 'خطا در انجام عملیات!',
                        imageUrl: require('../../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                        buttonType: 'close',//close
                        buttonText: 'تایید',
                        buttonLink: '',///personal-info
                        waitingMode: false
                    };
                }
            },
            async getClientWorkingSteps() {
                try {
                    this.loadingMood = true;
                    const response = await axios.get('api/userDashboard/getClientWorkingSteps', {headers: {"Authorization": `Bearer ${localStorage.getItem('token')}`}});
                    this.loadingMood = false;
                    this.workingSteps = response.data.results;

                } catch (error) {
                    this.loadingMood = false;
                    this.alertContent = {
                        message: 'خطا در انجام عملیات!',
                        imageUrl: require('../../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                        buttonType: 'close',//close
                        buttonText: 'تایید',
                        buttonLink: '',///personal-info
                        waitingMode: false
                    };
                }
            },
        },
        components: {
            NewsView,
            Alert,
            PanelLoader
        },
        mounted() {
            this.checkSlider();
            this.getClientDashboardInfos();
            this.getClientRelatedPosts();
            this.getClientWorkingSteps();
        }
    }
</script>

<style scoped lang="scss">
    .user-home-body{
        margin-top: 15px;
    }
    .empty-box{
        width: 100%;
        background-color: #f5f6fa;
        display: flex;
        justify-content: center;
        align-items: center;



        opacity: 0.7;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #162336;
        padding: 11px 10px;
        cursor: pointer;
        transition: all 0.1s ease;
        border-radius: 10px;


    }
    .waiting-box{
        height: 50px;
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0.7;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #162336;
        padding: 11px 10px;
        cursor: pointer;
        transition: all 0.1s ease;
        background-color: #f5f6fa;
        border-radius: 10px;
    }

    .waiting, .reviewed, .in-process {
        img {
            filter: drop-shadow(0 0 .5px black) drop-shadow(0 0 .5px black) drop-shadow(0 0 .5px black) drop-shadow(0 0 .5px black) drop-shadow(0 0 .5px black)
        }
    }


    .news-container {
        overflow: hidden;
        overflow-y: scroll;
        width: 100%;
        height: 270px;
        margin: 0;
        position: relative;
        z-index: 0;
    }

    #action-steps-parent-container {
        width: auto;
        height: auto;
        position: relative;
    }

    .start {
        //margin-right: -5px!important;
    }

    #more-details {
        transition: all ease 0.5s;
        opacity: 0;
        padding: 10px;
        /*display: none;*/
        left: 0;
        /*right: 0;*/
        /*margin: auto;*/
        bottom: 55px;
        position: absolute;
        z-index: 10000;
        width: 321px;
        min-height: 156px;
        border: solid 0.5px #162336;
        border-radius: 5px;
        background-color: #ffffff;
    }

    .file-details {
        .mobile-view {
            opacity: 0.5;
            font-family: IRANSans;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: right;
            color: #1a1a1a;
            display: none;
        }
    }



    .reviewed ,  .in-process{
        color: white;
    }

    .waiting {
        color: black;
    }


    .middle {
        margin-right: -40px;
    }

    .end {
        margin-right: -50px;
    }

    #action-steps-parent {
        cursor: move;
        position: relative;
        overflow-y: hidden;
        overflow-x: scroll;
        /*border-right: solid 2px #162336;*/
        background-color: #ffffff;

        ul {
            list-style-type: none;
            padding: 0 !important;
            width: max-content;

            li {
                -webkit-touch-callout: none; /* iOS Safari */
                -webkit-user-select: none; /* Safari */
                -khtml-user-select: none; /* Konqueror HTML */
                -moz-user-select: none; /* Old versions of Firefox */
                -ms-user-select: none; /* Internet Explorer/Edge */
                user-select: none;
                /* Non-prefixed version, currently
                                                 supported by Chrome, Edge, Opera and Firefox */
                display: inline-block;
                width: 183px;
                height: 50px;
                line-height: 50px;
                background-size: contain;
                background-repeat: no-repeat;
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                letter-spacing: normal;
                position: relative;

                span {
                    position: absolute;
                    top: 0%;
                    right: 0%;
                    bottom: 0%;
                    left: 0%;
                    margin: auto;
                    z-index: 10;
                }

                img {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    top: 0;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    z-index: 0;
                }

                &:hover {
                    z-index: 100 !important;

                    img {
                        filter: drop-shadow(0 0 .5px #fe7063) drop-shadow(0 0 .5px #fe7063) drop-shadow(0 0 .5px #fe7063) drop-shadow(0 0 .5px #fe7063) drop-shadow(0 0 .5px #fe7063) drop-shadow(0 0 .5px #fe7063) drop-shadow(0 0 .5px #fe7063) drop-shadow(0 0 .5px #fe7063);
                    }
                }


            }
        }

        width: 100%;
        height: 50px;
        padding: 0;
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;

        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        /*background-color: #ffffff;*/
        margin-top: 18px;
    }

    #action-steps-parent::-webkit-scrollbar {
        display: none;
        width: 2px;
    }

    /* Hide scrollbar for IE, Edge and Firefox */
    #action-steps-parent {
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
    }


    .file-details {
        width: 100%;
        /*background-color: #4285f4;*/
        height: auto;

        div {
            direction: ltr;
            width: 50%;
            display: inline-block;

            &:nth-child(1) {
                text-align: right;
                opacity: 0.5;
                font-family: IRANSans;
                font-size: 16px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: right;
                color: #1a1a1a;
            }

            &:nth-child(2) {
                text-align: right;
                opacity: 0.5;
                font-family: IRANSans;
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #1a1a1a;
            }
        }
    }


    /**title arrow**/
    .title {
        //margin-top: -20px;
        text-align: right;
        font-size: 20px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #1a1a1a;
        padding: 0;

        ul {
            display: flex;
            align-items: center;
            justify-content: right;
            list-style-type: none;
            padding: 0;

            li {
                background-color: white;
                padding: 0 0 0 15px;

                img {
                    margin-top: 5px;
                    width: 9px !important;
                    height: auto !important;
                }

                font-size: 22px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: justify;
                color: #1a1a1a;
                display: inline-block;

                span {
                    color: #cc171d;
                }

            }
        }

    }

    .form-title {
        ul {
            z-index: 10;
            position: relative;
            li {
                font-size: 20px !important;
            }
        }

    }

    /**title arrow**/

    #user-home {
        width: 100%;
        height: 100%;
        padding: 20px;
    }

    .user-home-header {
        min-height: 170px;
        height: auto;
        //border-top: solid 1px rgba(178, 178, 178, 0.5);
        //border-bottom: solid 1px rgba(178, 178, 178, 0.5);

    }
    .line{
        position: absolute!important;
       height: 2px;
        background-color: rgba(178, 178, 178, 0.5);
        width: 100%;
        top: 15px;
        z-index: 0;
    }

    @media (max-width: 1300px) {
        .file-details {
            span {
                display: inline;
            }

            .file-details-section-one {
                display: none;
            }

            .file-details-section-two {
                display: none;
            }
        }

    }
    .file-details-section-two{
        text-align: left!important;
    }
    #more-details-title {
        ul {
            li {
                font-size: 18px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #162336;
            }
        }

        margin-top: 0px;
    }

    #more-details-text-content {
        width: 100%;
        height: auto;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 2.92;
        letter-spacing: normal;
        text-align: justify;
        color: #162336;
    }

    @media(max-width: 1300px) {
        .mobile-view {
            display: inline!important;
        }
        .user-home-header {
            min-height: 250px;
        }
        #more-details {
            display: none;
        }
    }
</style>